
  <div class="loader-licenses" *ngIf="activitiesLoading">
    <app-loader></app-loader>
  </div>

  <p *ngIf="activitiesError !== 'DEFAULT' "> {{ activitiesError }}</p>
  <p *ngIf="!activitiesLoading && activitiesError === 'DEFAULT' &&  activitiesUser.length === 0">No tienes ninguna actividad reciente.</p>
<div class="table table--history" *ngIf="!activitiesLoading && activitiesUser.length > 0">
  <div class="thead">
    <div class="tr">
      <div class="th hover-hand" (click)="setOrder('asset')">
        <div class="table-head headerTable">
          <p> Asset</p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'asset' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'asset' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th hover-hand" (click)="setOrder('requirementType')">
        <div class="table-head headerTable">
          <p>Tipo actividad</p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'requirementType' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'requirementType' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'requirementType' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'requirementType' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th hover-hand" (click)="setOrder('createdAt')">
        <div class="table-head headerTable">
          <p>Fecha actividad</p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'createdAt' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'createdAt' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'createdAt' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'createdAt' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th hover-hand" (click)="setOrder('id')">
        <div class="table-head headerTable">
          <p>Nº solicitud</p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'id' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'id' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'id' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'id' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th hover-hand" (click)="setOrder('licenseId')">
        <div class="table-head headerTable">
          <p>Nº licencia</p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'licenseId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'licenseId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'licenseId' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'licenseId' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="tbody desktop">
    <div class="tr row-height" *ngFor="let activity of activitiesUser | orderBy : order : reverse : true ; let i = index">
      <div class="td td--number row-content">
        <p class="row-field">{{activity.asset}}</p>
      </div>

      <div class="td td--button showTogleAct row-content">
        <p class="row-field">{{activity.requirementType}}</p>
      </div>
      <div class="td td--status row-content">
        <p class="row-field"><span class="mr-2">Fecha:</span>{{activity.createdAt |dateFromBack}}</p>
      </div>

      <div class="td td--body  desktopInfoActivity row-content">
        <p class="row-field"><span>Número de solicitud:
          </span>{{activity.id}}</p>
      </div>
      <div class="td td--body  desktopInfoActivity row-content">
        <p class="row-field"><span>Número de licencia:
          </span>{{activity.numberLicense}}</p>
      </div>
    </div>
  </div>
  <div class="tbody mobile">

    <mat-accordion>

      <div *ngFor="let activity of activitiesUser | orderBy : order : reverse : false; let i = index">
        <mat-expansion-panel class="tableRowsResponsive" (opened)="panelOpenState = true"
          (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="assetName">
              <div class="containerP">
                <p>{{activity.asset}}</p>
              </div>
            </mat-panel-title>
            <mat-panel-description class="descriptionAct">
              <p>{{activity.requirementType}}</p>
              <p class="textDate"><span class="mr-2">Fecha:</span>{{activity.createdAt | dateFromBack }}</p>

            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="bodyDetail">
            <p *ngIf="activity.requirementStatus === 'En Proceso'"><span>Número de
                solicitud:</span>{{activity.licenseId}}</p>
            <p *ngIf="activity.requirementStatus === 'Aprobada'"><span>Número de licencia:</span>{{activity.licenseNumber}}
            </p>
          </div>

        </mat-expansion-panel>
      </div>

    </mat-accordion>
  </div>

</div>
<a class="btn btn--link btn--link--secondary btn--link--secondary--big btn--link--secondary--bold btn--link--secondary--color mt-2 pl-0"
  routerLink="/recent-activities" *ngIf="!activitiesLoading && activitiesUser.length > 0">Ver historial completo de actividades</a>
